import { render, staticRenderFns } from "./SupplyHeader.vue?vue&type=template&id=23bcc134&"
import script from "./SupplyHeader.vue?vue&type=script&lang=js&"
export * from "./SupplyHeader.vue?vue&type=script&lang=js&"
import style0 from "./SupplyHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports